import styled, { css } from 'styled-components';

export const buttonResetStyle = css`
  padding: 0;
  margin: 0;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  color: currentColor;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  cursor: pointer;
`;

export const ButtonReset = styled.button`
  ${buttonResetStyle};
  line-height: ${(props) => props.theme.font.lineHeight.main};
  font-size: ${(props) => props.theme.font.size.regular};
`;

const inputPlaceholderStyle = css`
  font-family: var(--font-family);
  font-weight: var(--font-weight-regular);
  color: var(--c-text-muted);
`;

export const inputPlaceholder = css`
  &::-webkit-input-placeholder {
    ${inputPlaceholderStyle}
  }

  &:-moz-placeholder {
    ${inputPlaceholderStyle}
  }

  &::-moz-placeholder {
    ${inputPlaceholderStyle}
  }

  &:-ms-input-placeholder {
    ${inputPlaceholderStyle}
  }
`;

export const inputPlaceholderVisuallyHidden = css`
  &::-webkit-input-placeholder {
    color: transparent;
  }

  &:-moz-placeholder {
    color: transparent;
  }

  &::-moz-placeholder {
    color: transparent;
  }

  &:-ms-input-placeholder {
    color: transparent;
  }
`;
